export default function Process() {
  const steps = [
    {
      number: '01',
      title: 'Discovery & Strategy',
      description: 'We start by understanding your business goals, target audience, and project requirements. Through detailed consultation, we craft a strategic roadmap tailored to your vision.',
      icon: 'ri-search-line',
      color: 'from-purple-500 to-blue-500'
    },
    {
      number: '02',
      title: 'Design & Prototyping',
      description: 'Our design team creates stunning UI/UX mockups and interactive prototypes. We focus on modern aesthetics, user experience, and conversion optimization.',
      icon: 'ri-palette-line',
      color: 'from-blue-500 to-cyan-500'
    },
    {
      number: '03',
      title: 'Development & Testing',
      description: 'Expert developers bring designs to life with clean, efficient code. Rigorous testing ensures your solution is fast, secure, and bug-free across all devices.',
      icon: 'ri-code-s-slash-line',
      color: 'from-cyan-500 to-green-500'
    },
    {
      number: '04',
      title: 'Launch & Support',
      description: 'We handle deployment, optimization, and provide ongoing support. Your success is our priority with 24/7 monitoring and continuous improvements.',
      icon: 'ri-rocket-line',
      color: 'from-green-500 to-emerald-500'
    }
  ];

  return (
    <section id="process" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-purple-600 font-semibold text-sm uppercase tracking-wider">Our Process</span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mt-4 mb-6">
            How We Work
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            A proven methodology that delivers exceptional results every time. From initial concept to final launch, we're with you every step of the way.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative group">
              <div className="bg-white rounded-3xl p-8 border border-gray-100 hover:shadow-xl transition-all duration-300 cursor-pointer h-full">
                <div className={`inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-br ${step.color} mb-6 group-hover:scale-110 transition-transform`}>
                  <i className={`${step.icon} text-3xl text-white`}></i>
                </div>
                
                <div className="text-6xl font-bold text-gray-100 mb-4">{step.number}</div>
                
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  {step.title}
                </h3>
                
                <p className="text-gray-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
              
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                  <i className="ri-arrow-right-line text-3xl text-purple-300"></i>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
